import { Component } from '@angular/core';
import { FileManagerComponent } from 'src/app/components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-it-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './it-file-manager.component.html',
  styleUrl: './it-file-manager.component.scss',
})
export class ItFileManagerComponent {
hrInitialPath: string = 'it';

}
